import { type UniversalFiltersStoreContext } from './store.types';

/**
 * In-memory filter-state cache for provider remounts during in-app navigation.
 * This is intentionally process-local only: no sessionStorage or URL usage,
 * and it resets on hard reload/tab close.
 */
const filterStateCache = new Map<string, UniversalFiltersStoreContext>();

export function readCachedFilterState(key: string) {
  return filterStateCache.get(key);
}

export function writeCachedFilterState(
  key: string,
  context: UniversalFiltersStoreContext,
) {
  filterStateCache.set(key, context);
}

export function clearFilterStateCache() {
  filterStateCache.clear();
}
